import { SWRConfiguration } from 'swr';

import { useSWR } from '@/hooks/useSwr';
import { HostListenerSchema } from '@/types/schema';
import { hostApiListenersPath } from '@/utils/constants';

export const useHostListener = (id?: string, options?: SWRConfiguration) => {
  return useSWR<HostListenerSchema>(
    id ? { url: `${hostApiListenersPath}/${id}` } : null,
    options
  );
};
